import React, { PureComponent } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import Table from 'rc-table';
import { Link } from 'react-router';
import { MenuItem } from 'material-ui';
import { TextBlock } from 'react-placeholder/lib/placeholders';
import WarningIcon from 'material-ui/svg-icons/alert/warning';
import { BooleanField } from '../helpers';
import { CAMPAIGN_FORM_KEYS, LOADING_COLOR, LOADING_CLASSNAME } from 'dash-front/constants';
import { SMLinkTitle } from '../../containers/SMLink';

const RC_TABLE_COLUMNS = [
    {
        key: CAMPAIGN_FORM_KEYS.TITLE,
        dataIndex: CAMPAIGN_FORM_KEYS.TITLE,
        title: 'Title',
        render: (value, { _id }) => (
            <Link to={`/campaigns/view/${_id}`}>
                <MenuItem primaryText={value} />
            </Link>
        ),
    },
    {
        key: CAMPAIGN_FORM_KEYS.ACTIVE,
        dataIndex: CAMPAIGN_FORM_KEYS.ACTIVE,
        render: value => <BooleanField value={value} />,
        title: 'Active',
    },
    {
        key: CAMPAIGN_FORM_KEYS.MODERATION,
        dataIndex: CAMPAIGN_FORM_KEYS.MODERATION,
        render: value => <BooleanField value={value} />,
        title: 'Moderation',
    },
    {
        key: CAMPAIGN_FORM_KEYS.TARGETS.ARRAY,
        dataIndex: CAMPAIGN_FORM_KEYS.TARGETS.ARRAY,
        render: targets =>
            targets.map(target => {
                return (
                    <div key={target.value}>
                        <SMLinkTitle id={target.value} />
                    </div>
                );
            }),
        title: 'Targets',
    },
    {
        key: 'likes',
        render: ({ stats }) => (
            <div>
                <div>This week: {get(stats, 'thisWeek.total.likes', 'n/a')}</div>
                <div>Last week: {get(stats, 'lastWeek.total.likes', 'n/a')}</div>
            </div>
        ),
        title: 'Likes',
    },
    {
        key: 'views',
        render: ({ stats }) => (
            <div>
                <div>This week: {get(stats, 'thisWeek.facebook.impressions', 'n/a')}</div>
                <div>Last week: {get(stats, 'lastWeek.facebook.impressions', 'n/a')}</div>
            </div>
        ),
        title: 'FB views',
    },
];

export default class CampaignsList extends PureComponent {
    renderTable() {
        const { campaigns, campaignsPending, campaignsStatus } = this.props;
        const showTable = campaignsPending || Array.isArray(campaigns);
        const data = Array.isArray(campaigns) ? campaigns : [];
        if (showTable) {
            return (
                <Table
                    columns={RC_TABLE_COLUMNS}
                    data={data}
                    rowKey="_id"
                    emptyText={
                        <div>
                            <TextBlock rows={7} color={LOADING_COLOR} className={LOADING_CLASSNAME} />
                        </div>
                    }
                />
            );
        }
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}
            >
                <WarningIcon />
                <p>Error while fetching campaigns</p>
                <p>Status code: {campaignsStatus}</p>
            </div>
        );
    }

    render() {
        return <div className="wdp-container">{this.renderTable()}</div>;
    }
}

CampaignsList.propTypes = {
    campaigns: PropTypes.array,
    smlinks: PropTypes.array,
    campaignsPending: PropTypes.bool,
    campaignsStatus: PropTypes.number,
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/List/CampaignsList.js
 **/